// extracted by mini-css-extract-plugin
export default {"closeBlock":"CloseBlock_closeBlock__boOoT","closeBlockIcon":"CloseBlock_closeBlockIcon__FBfCQ","bgPulse":"CloseBlock_bgPulse__QZDAU"};